module.exports = __webpack_public_path__ + "static/media/need-kids.f059ed3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/need/need-kids.jpg
// module id = 373
// module chunks = 0